import {  useQuery } from "react-query";
import { getOrganisation } from "../apis/organisation";
import { UIOrganisation } from "../../../../packages/types/src/organisation";

export const useOriganisation = (orgId?:string) => {
  return useQuery({
    queryKey: ["getOrganisation",orgId],
    queryFn: async () => (await getOrganisation({orgId})).data.organisation as UIOrganisation,
    staleTime: 60000,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!orgId,
  });
};

